<!-- Contenitore principale: immagine + overlay + tooltip -->
<div
  #container
  class="coverage-container"
  [class.tool-select]="interactionTool === 'select'"
  [class.tool-place-ap]="interactionTool === 'place-ap'"
  [class.tool-draw-obstacle]="interactionTool === 'draw-obstacle'"
  [class.tool-measure]="interactionTool === 'measure'"
  [class.tool-pan]="interactionTool === 'pan'"
  [style.background-image]="'url(' + floorplanUrl + ')'"
  role="img"
  [attr.aria-label]="i18n.translate('coverage.floorplan.ariaLabel')"
  (pointermove)="onPointerMove($event)"
  (pointerleave)="onPointerLeave()"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerCancel()"
  (pointerdown)="onContainerPointerDown($event)"
>
  <!-- Canvas gestito da heatmap.js -->
  <div
    #heatmapLayer
    class="overlay heatmap"
    [class.active]="mode === 'heatmap' || mode === 'heatmap-soft'"
    [style.opacity]="mode === 'heatmap' || mode === 'heatmap-soft' ? heatmapOpacity : 0"
  ></div>
  <scichart-angular
    class="overlay scichart"
    [class.active]="mode === 'scichart'"
    [initChart]="initSciChart"
    [style.opacity]="mode === 'scichart' ? heatmapOpacity : 0"
  ></scichart-angular>

  <!-- Layer SVG per le isobande -->
  <svg
    #contoursLayer
    class="overlay contours"
    [class.active]="mode === 'contours' || mode === 'contours-lines' || mode === 'contours-marching' || mode === 'contours-heatmapjs'"
    [class.lines-only]="mode === 'contours-lines'"
    [style.opacity]="mode === 'contours' || mode === 'contours-lines' || mode === 'contours-marching' || mode === 'contours-heatmapjs' ? heatmapOpacity : 0"
    [attr.viewBox]="viewBox"
    preserveAspectRatio="none"
  >
    <g *ngFor="let path of contourPaths; trackBy: trackByPath">
      <path
        [attr.d]="path.d"
        [attr.fill]="mode === 'contours-lines' ? 'none' : path.color"
        [attr.fill-opacity]="mode === 'contours-lines' ? 0 : 0.7"
        [attr.stroke]="path.color"
        [attr.stroke-width]="mode === 'contours-lines' ? 2 : 1.25"
        [attr.stroke-dasharray]="mode === 'contours-lines' ? '6 6' : null"
      ></path>
    </g>
  </svg>

  <svg
    class="antenna-lines"
    [attr.viewBox]="viewBox"
    preserveAspectRatio="none"
  >
    <g *ngFor="let ap of accessPoints; let idx = index">
      <line
        [attr.x1]="apPositionX(ap, idx, 'start')"
        [attr.y1]="apPositionY(ap, idx, 'start')"
        [attr.x2]="apPositionX(ap, idx, 'end')"
        [attr.y2]="apPositionY(ap, idx, 'end')"
        stroke="rgba(255,255,255,0.75)"
        stroke-width="3"
        stroke-linecap="round"
      ></line>
    </g>
  </svg>

  <svg
    class="obstacle-lines"
    [attr.viewBox]="viewBox"
    preserveAspectRatio="none"
  >
    <g *ngFor="let ob of obstacles; let idx = index">
      <line
        [attr.x1]="obstaclePositionX(ob, idx, 'start')"
        [attr.y1]="obstaclePositionY(ob, idx, 'start')"
        [attr.x2]="obstaclePositionX(ob, idx, 'end')"
        [attr.y2]="obstaclePositionY(ob, idx, 'end')"
        [attr.stroke]="obstacleStrokeColor(ob)"
        [attr.stroke-width]="obstacleStrokeWidth(ob)"
        stroke-linecap="round"
        stroke-opacity="0.8"
      ></line>
    </g>
  </svg>

  <svg class="interaction-lines" [attr.viewBox]="viewBox" preserveAspectRatio="none">
    <ng-container *ngIf="draftObstacle as draft">
      <line
        [attr.x1]="draftPositionX(draft.start)"
        [attr.y1]="draftPositionY(draft.start)"
        [attr.x2]="draftPositionX(draft.end)"
        [attr.y2]="draftPositionY(draft.end)"
        class="draft-line"
      ></line>
    </ng-container>
    <ng-container *ngIf="measurementDraft as measure">
      <line
        [attr.x1]="draftPositionX(measure.start)"
        [attr.y1]="draftPositionY(measure.start)"
        [attr.x2]="draftPositionX(measure.end)"
        [attr.y2]="draftPositionY(measure.end)"
        class="measure-line"
      ></line>
    </ng-container>
  </svg>

  <div class="ap-layer" aria-hidden="false">
    <ng-container *ngFor="let ap of accessPoints; let idx = index">
      <button
        type="button"
        class="ap-node start"
        [class.interaction-disabled]="interactionTool !== 'select'"
        [class.dragging]="draggingAp?.index === idx && draggingAp?.handle === 'start'"
        [style.left.px]="apPositionX(ap, idx, 'start')"
        [style.top.px]="apPositionY(ap, idx, 'start')"
        (pointerdown)="onApPointerDown($event, idx, 'start')"
        (click)="onAntennaSelect($event, idx)"
        (contextmenu)="onAntennaContextMenu($event, idx)"
        [attr.aria-label]="i18n.translate('coverage.antenna.base')"
      >
        <span class="icon">📡</span>
        <span class="label">{{ i18n.translate('coverage.antenna.label') }} {{ idx + 1 }}</span>
      </button>
      <button
        type="button"
        class="ap-node end"
        [class.interaction-disabled]="interactionTool !== 'select'"
        [class.dragging]="draggingAp?.index === idx && draggingAp?.handle === 'end'"
        [style.left.px]="apPositionX(ap, idx, 'end')"
        [style.top.px]="apPositionY(ap, idx, 'end')"
        (pointerdown)="onApPointerDown($event, idx, 'end')"
        (click)="onAntennaSelect($event, idx)"
        (contextmenu)="onAntennaContextMenu($event, idx)"
        [attr.aria-label]="i18n.translate('coverage.antenna.end')"
      >
        <span class="icon">⟡</span>
      </button>
      <button
        type="button"
        class="ap-node center"
        [class.interaction-disabled]="interactionTool !== 'select'"
        [class.dragging]="draggingAp?.index === idx && draggingAp?.handle === 'center'"
        [style.left.px]="(apPositionX(ap, idx, 'start') + apPositionX(ap, idx, 'end')) / 2"
        [style.top.px]="(apPositionY(ap, idx, 'start') + apPositionY(ap, idx, 'end')) / 2"
        (pointerdown)="onApPointerDown($event, idx, 'center')"
        (click)="onAntennaSelect($event, idx)"
        (contextmenu)="onAntennaContextMenu($event, idx)"
        [attr.aria-label]="i18n.translate('coverage.antenna.drag')"
      >
        <span class="icon">↕</span>
      </button>
    </ng-container>
    <ng-container *ngFor="let ob of obstacles; let idx = index">
      <button
        type="button"
        class="ob-node start"
        [class.interaction-disabled]="interactionTool !== 'select'"
        [class.dragging]="draggingObstacle?.index === idx && draggingObstacle?.handle === 'start'"
        [style.left.px]="obstaclePositionX(ob, idx, 'start')"
        [style.top.px]="obstaclePositionY(ob, idx, 'start')"
        (pointerdown)="onObstaclePointerDown($event, idx, 'start')"
        (click)="onObstacleSelect($event, idx)"
        (contextmenu)="onObstacleContextMenu($event, idx)"
        [attr.aria-label]="i18n.translate('coverage.obstacle.start')"
      >
        <span class="icon">⬦</span>
      </button>
      <button
        type="button"
        class="ob-node end"
        [class.interaction-disabled]="interactionTool !== 'select'"
        [class.dragging]="draggingObstacle?.index === idx && draggingObstacle?.handle === 'end'"
        [style.left.px]="obstaclePositionX(ob, idx, 'end')"
        [style.top.px]="obstaclePositionY(ob, idx, 'end')"
        (pointerdown)="onObstaclePointerDown($event, idx, 'end')"
        (click)="onObstacleSelect($event, idx)"
        (contextmenu)="onObstacleContextMenu($event, idx)"
        [attr.aria-label]="i18n.translate('coverage.obstacle.end')"
      >
        <span class="icon">⬦</span>
      </button>
      <button
        type="button"
        class="ob-node center"
        [class.interaction-disabled]="interactionTool !== 'select'"
        [class.dragging]="draggingObstacle?.index === idx && draggingObstacle?.handle === 'center'"
        [style.left.px]="(obstaclePositionX(ob, idx, 'start') + obstaclePositionX(ob, idx, 'end')) / 2"
        [style.top.px]="(obstaclePositionY(ob, idx, 'start') + obstaclePositionY(ob, idx, 'end')) / 2"
        (pointerdown)="onObstaclePointerDown($event, idx, 'center')"
        (click)="onObstacleSelect($event, idx)"
        (contextmenu)="onObstacleContextMenu($event, idx)"
        [attr.aria-label]="i18n.translate('coverage.obstacle.drag')"
      >
        <span class="icon">⎯</span>
      </button>
    </ng-container>
  </div>

  <!-- Tooltip responsive ancorato al cursore -->
  <div
    class="tooltip"
    *ngIf="tooltip as hint"
    [style.left.px]="hint.x"
    [style.top.px]="hint.y"
  >
    <div class="tooltip-label">{{ i18n.translate('coverage.tooltip.signal') }}</div>
    <div class="tooltip-value">{{ hint.value | number: '1.0-1' }} dBm</div>
  </div>

  <div
    class="measure-badge"
    *ngIf="measurementDraft && measurementDistance() !== undefined"
    [style.left.px]="measurementLabelX()"
    [style.top.px]="measurementLabelY()"
  >
    {{ measurementDistance() | number: '1.0-1' }} px
  </div>
</div>
